import styles from './style.postcss';

import React, { Component } from 'react';
import { PageCard, NumberInput, HorizontalScroll } from 'omni-common-ui';
import { HeaderTd, TableViewTr } from './';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import debounce from 'lodash.debounce';
import is from 'is_js';
import PageSelector from 'components/PageSelector';

const DEFAULT_PAGE_SIZE = 10;

class TableView extends Component {
  constructor(props) {
    super(props);
    this.state = { pageSize: this._calculateDefaultPageSize(props) };
    this._onNumberOfItemsPerPageChanged =
      this._onNumberOfItemsPerPageChanged.bind(this);
    this._onNumberOfItemsPerPageChanged = debounce(
      this._onNumberOfItemsPerPageChanged,
    );
  }

  componentWillReceiveProps(newProps) {
    if (newProps.query.pageSize !== this.props.query.pageSize) {
      return this.setState({ pageSize: newProps.query.pageSize });
    }

    if (newProps.totalRecords !== this.props.totalRecords) {
      return this.setState({
        pageSize: this._calculateCurrentPageSize(newProps),
      });
    }
  }

  _calculateDefaultPageSize(props) {
    const totalRecords = parseInt(props.totalRecords, 10);
    return totalRecords < DEFAULT_PAGE_SIZE ? totalRecords : DEFAULT_PAGE_SIZE;
  }

  _calculateCurrentPageSize(props) {
    const pageSize = props.query.pageSize;
    const totalRecords = parseInt(props.totalRecords, 10);
    if (pageSize) {
      return pageSize < totalRecords ? pageSize : totalRecords;
    }
  }

  _renderHeaders() {
    const { headers, query, customerHeader } = this.props;
    if (customerHeader) {
      return customerHeader;
    }

    if (!headers) {
      return null;
    }

    return (
      <TableViewTr>
        {headers.map((header) => (
          <HeaderTd
            sortable={header.sortable}
            sortType={query.sortBy === header.key ? query.sortType : ''}
            onSort={(sortType) => {
              this._filterChange({
                sortBy: header.key,
                sortType,
                pageNumber: 1,
              });
            }}
          >
            {header.text}
          </HeaderTd>
        ))}
      </TableViewTr>
    );
  }

  _filterChange(query) {
    if (!(this.state.pageSize > 0)) return;
    const { onFilterChange } = this.props;
    if (onFilterChange) {
      onFilterChange(Object.assign({}, this.props.query, query));
    }
  }

  _onNumberOfItemsPerPageChanged(value) {
    this.setState({ pageSize: value });
    if (is.not.number(value)) {
      return;
    }

    this._filterChange({ pageSize: value, pageNumber: 1 });
  }

  _renderPagination() {
    const { totalRecords, query } = this.props;
    if (!this.props.pageable || totalRecords <= 0) {
      return null;
    }

    const pageNumber = parseInt(query.pageNumber, 10);
    const pageSize = parseInt(query.pageSize, 10) || 10;
    const totalPages = Math.ceil(totalRecords / pageSize);
    if (pageNumber > totalPages) {
      this._filterChange({ pageNumber: totalPages });
      return null;
    }

    return (
      <div className={styles.TableView_pagination}>
        <PageSelector
          current={pageNumber}
          last={totalPages}
          onChange={(page) => this._onPageChange(page)}
        />
      </div>
    );
  }

  _onPageChange(value) {
    this._filterChange({ pageNumber: value });
  }

  _renderInputItemsPerPage() {
    const totalRecords = parseInt(this.props.totalRecords, 10);
    return (
      <div className={styles.TableView_numberSetting_numberInputItem}>
        <NumberInput
          value={this.state.pageSize}
          className={styles.TableView_numberInput}
          min="1"
          max={totalRecords}
          onChange={this._onNumberOfItemsPerPageChanged}
        />
        <span className={styles.TableView_numberSetting_space}>
          Items per page (of {totalRecords})
        </span>
      </div>
    );
  }

  _renderPageSizeControl() {
    const { totalRecords, pageable, customerPageControlRightPart } = this.props;
    if ((!pageable || totalRecords <= 0) && !customerPageControlRightPart)
      return null;
    return (
      <div className={styles.TableView_numberSetting}>
        {this._renderInputItemsPerPage()}
        {customerPageControlRightPart}
      </div>
    );
  }

  render() {
    const {
      tableTitle,
      source,
      renderTableRow,
      noResultsString,
      customerFooter,
      className,
    } = this.props;

    return (
      <PageCard className={classnames(styles.TableView, className)}>
        {tableTitle && <PageCard.Heading text={tableTitle} />}
        {this._renderPageSizeControl()}
        <HorizontalScroll>
          <table className={styles.TableView_table}>
            <thead>{this._renderHeaders()}</thead>
            <tbody>{source.map((row) => renderTableRow(row))}</tbody>
          </table>
        </HorizontalScroll>
        {this._renderPagination()}
        {(!source || source.length === 0) && noResultsString && (
          <div className={styles.TableView_noResults}>{noResultsString}</div>
        )}
        {customerFooter}
      </PageCard>
    );
  }
}

TableView.propTypes = {
  tableTitle: PropTypes.string,
  headers: PropTypes.array,
  source: PropTypes.array,
  renderTableRow: PropTypes.func,
  pageable: PropTypes.bool,
  noResultsString: PropTypes.string,
  query: PropTypes.object,
  onFilterChange: PropTypes.func,
  customerHeader: PropTypes.object,
  customerFooter: PropTypes.node,
  totalRecords: PropTypes.number,
  className: PropTypes.string,
  customerPageControlRightPart: PropTypes.node,
};

export default TableView;



// WEBPACK FOOTER //
// ./components/TableView/TableView.jsx